/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_HighlightInputs */

const et_plan_visibility_highlight = /** @type {(inputs: Plan_Visibility_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rohkem külastajaid`)
};

const en_plan_visibility_highlight = /** @type {(inputs: Plan_Visibility_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More visitors`)
};

/**
* | output |
* | --- |
* | "More visitors" |
*
* @param {Plan_Visibility_HighlightInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_highlight = /** @type {((inputs?: Plan_Visibility_HighlightInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_HighlightInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_highlight(inputs)
	return en_plan_visibility_highlight(inputs)
});